angular.module('FlexyBeautyApp.services')
    .factory('CureStatus',function () {
        return {
            ACTIVE             : "active",
            USED               : "used",
            CLOSED             : "closed"
        };
    });


// WEBPACK FOOTER //
// ./js/services/views/ConstantsCureStatus.js